import React, { Fragment } from 'react';
import Head from 'next/head';
import { string } from 'prop-types';
import { addTrackingParams } from 'components/PinItButton/helpers';

function AmpPinterest({ url, media, description }) {
  return (
    <Fragment>
      <Head>
        <script
          key="amp-pinterest"
          async
          custom-element="amp-pinterest"
          src="https://cdn.ampproject.org/v0/amp-pinterest-0.1.js"
        />
      </Head>
      <amp-pinterest
        height="32"
        width="32"
        data-round="true"
        data-tall="true"
        data-do="buttonPin"
        data-url={addTrackingParams(url)}
        data-media={media}
        data-description={description}
      />
    </Fragment>
  );
}

AmpPinterest.propTypes = {
  description: string.isRequired,
  media: string.isRequired,
  url: string.isRequired
};

export default AmpPinterest;
